import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useState} from 'react';
import usePendingHandler from '@shared/usePendingHandler';
import PreventForm from '@shared/PreventForm';
import useApiError from '@di-shared/features/common/useApiError';
import {diApi} from '@di-shared/api/di';
import environmentStore from '@di-shared/features/environment/environmentStore';
import type {GetUbiThirdPartyTermsResponse} from '@di-shared/api/di/__generated';
import {emitEventLog} from '@di-shared/features/analytics';
import DOMPurify from 'dompurify';

export interface SafeDrivingAgreeBottomSheetKrProps {
  vin: string;
  termsData: GetUbiThirdPartyTermsResponse;
}

function SafeDrivingAgreeBottomSheetKr({vin, termsData}: SafeDrivingAgreeBottomSheetKrProps) {
  const {t} = useInferableTranslation();

  const [isTermsPage, setIsTermsPage] = useState<boolean>(false);
  const {resolveError} = useApiError();
  const puid = environmentStore.getState().puid;

  const [submitAgreeSafeDriving] = usePendingHandler(
    async () => {
      await diApi.ubiThirdPartyAgreementsController.updateAgreementsForSeviceDevelop1({
        requestBody: {
          puid,
          vin,
          isAgreed: true,
        },
      });
      window.bottomSheetClose(true);
    },
    async (error) => {
      await resolveError(error);
    }
  );

  return (
    <div className="bottom_sheet">
      {isTermsPage ? (
        <>
          <div className="bottom_sheet_header">
            <h2
              className="bottom_sheet_title"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T20216')}
            </h2>
            <button
              type="button"
              className="btn btn_ic"
              aria-label={t('T10017')}
              onClick={() => setIsTermsPage(false)}
            >
              <span
                className="ic ic_close_20px"
                aria-hidden="true"
              ></span>
            </button>
          </div>
          <div className="bottom_sheet_inner">
            <div
              className="bottom_sheet_contents"
              // [2025-07-11:dooking] FIXME: termsData 확인 필요
              dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(termsData.content || '')}}
            ></div>

            <div className="bottom_sheet_footer">
              <button
                type="button"
                className="btn btn_large btn_filled"
                onClick={() => {
                  setIsTermsPage(false);
                }}
              >
                {t('T10114')}
              </button>
            </div>
          </div>
        </>
      ) : (
        <PreventForm onSubmit={submitAgreeSafeDriving}>
          <div className="bottom_sheet_header">
            <h2
              className="bottom_sheet_title"
              id="bottomSheetTitle"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T20194')}
            </h2>
            <button
              type="button"
              className="btn btn_ic"
              aria-label={t('T10017')}
              onClick={() => window.bottomSheetClose(false)}
            >
              <span
                className="ic ic_close_20px"
                aria-hidden="true"
              ></span>
            </button>
          </div>
          <div className="bottom_sheet_inner">
            <div
              className="bottom_sheet_contents"
              id="bottomSheetDesc"
            >
              <strong
                className="bottom_sheet_title_sub"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20195')}
              </strong>

              <div className="consent_agree">
                <div className="divider"></div>
                <div className="consent_agree_item">
                  <p className="consent_agree_desc">{t('T20196')}</p>
                  <button
                    type="button"
                    className="btn btn_ic"
                    onClick={() => setIsTermsPage(true)}
                  >
                    <span
                      className="ic ic_arrow_forward_16px"
                      aria-hidden="true"
                    >
                      <span className="blind">{t('T10063')}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div className="bottom_sheet_footer bottom_sheet_footer_complex">
              <button
                type="button"
                className="btn btn_large btn_outline"
                onClick={() => window.bottomSheetClose(false)}
              >
                {t('T20119')}
              </button>
              <button
                type="submit"
                className="btn btn_large btn_filled"
                onClick={() =>
                  emitEventLog({
                    event: 'driving_insight_agreement',
                    interaction_type: 'agree',
                    click_text: t('T20120'),
                    click_location: 'body',
                  })
                }
              >
                {t('T20120')}
              </button>
            </div>
          </div>
        </PreventForm>
      )}
    </div>
  );
}

export default SafeDrivingAgreeBottomSheetKr;
